import { Box, Button, List, ListItem } from "@mui/material";
import React from "react";
import styles from "../../../styles/components/video.module.scss";
import styles1 from "../../../styles/components/submissionInformation.module.scss";
import { emptyHandle, getUtcDateTime } from "../../../lib/functions/utils.lib";

const SubmissionInformation = ({ data }) => {
    const submissionList = [
        {
            textheading: "Terms of Submission",
            textname: "Agreed | Exclusive License ",
        },
        {
            textheading: "Terms of Service",
            textname: "Agreed",
        },
        {
            textheading: "Submission date",
            textname: getUtcDateTime(data?.created_at),
        },
        {
            textheading: "Submission ID",
            textname: data?.id,
        },
        {
            textheading: "User IP address",
            textname: emptyHandle(data?.video_meta.ip_address),
        },
        {
            textheading: "Country",
            textname: emptyHandle(data?.country),
        },
        {
            textheading: "Acquired By",
            textname: emptyHandle(data?.user?.name),
        },
        {
            textheading: "Revenue Share:",
            textname: emptyHandle(data?.revenue_share),
        },
    ];
    return (
        <>
            {data && (
                <Box className="VideocommonBox">
                    <Box
                        className={`${styles.ownerDetails} ${styles1.purchaseInformation}`}
                    >
                        <Box
                            className={`${styles.commonHeading} ${styles1.commonHeading}`}
                        >
                            <h4>
                                <label>Submission Information</label>
                            </h4>
                        </Box>

                        <Box
                            className={`${styles.ownerDetailsTxt} ${styles1.ownerDetailsTxt}`}
                        >
                            <List>
                                {submissionList.map((item, index) => {
                                    return (
                                        <ListItem key={index}>
                                            <Box
                                                className={
                                                    styles.ownerDetailsTxtBox
                                                }
                                            >
                                                <h4>{item.textheading}</h4>
                                                <h5>{item.textname}</h5>
                                            </Box>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default SubmissionInformation;
